module.exports = __webpack_public_path__ + "8560704658d904233f57820a77029b9e.mp4";